module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/DesktopModalSidePanel.3a5b5e4.png";